const STORAGE_KEY = 'midulate-known-devices';

export default class KnownDevices {
  static getAll() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }

  static save(uid, host, version = null) {
    const all = KnownDevices.getAll();
    all[uid] = {
      uid,
      host,
      lastSeen: new Date().toISOString(),
      name: all[uid]?.name ?? null,
      version: version ?? all[uid]?.version ?? null,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  }

  static remove(uid) {
    const all = KnownDevices.getAll();
    delete all[uid];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  }
}
